/* eslint max-len: ["error", 200] */
/* eslint-env es6 */

require('./components/translations.js');

window.Reverb = window.Reverb || {};

require('isomorphic-fetch');
require('components/error_logger').init();
require('components/sentry');

window.User = require('./components/user.js');

require('./components/app_initializer.js').init();

if (window.__loadZendeskEmbed) {
  window.setTimeout(__loadZendeskEmbed, 1000); // Injected from rails
}

require('./components/legacy.js');
require('./components/discovery.js');

window.Reverb.APIRequest = require('./components/api_request.js');

require('./components/adyen_ujs');

window.Reverb.BundledCheckout = window.Reverb.BundledCheckout || {};
window.Reverb.BundledCheckout.ReverifyCreditCard = require('./components/bundled_checkout/reverify_credit_card.js');
window.Reverb.BundledCheckout.PollConfirmation = require('./components/bundled_checkout/poll_confirmation.js');
window.Reverb.BundledCheckout.PasswordOrGuestCheckoutSelection = require('./components/bundled_checkout/password_or_guest_checkout_selection.jsx');

window.Reverb.AddressList = require('./components/addresses/address_list.jsx');
window.Reverb.AsyncLoader = require('./components/async_loader.jsx');
window.Reverb.CreditCardList = require('./components/credit_cards/credit_card_list.jsx');

window.Reverb.CategorySelect = require('./components/category_select.jsx');
window.Reverb.ComparisonShoppingTabs = require('./components/comparison_shopping_page/comparison_shopping_tabs.jsx');
window.Reverb.Dashboard = window.Reverb.Dashboard || {};
window.Reverb.Dashboard.Imports = window.Reverb.Dashboard.Imports || {};
window.Reverb.Dashboard.Imports.ProgressBar = require('./components/dashboard/imports/progress_bar.jsx');
window.Reverb.Dashboard.Orders = window.Reverb.Dashboard.Orders || {};
window.Reverb.Dashboard.RefundRequestReason = require('./components/dashboard/refund_request_reason.jsx');
window.Reverb.Dashboard.Selling = window.Reverb.Dashboard.Selling || {};
window.Reverb.Dashboard.Selling.EmailOffers = window.Reverb.Dashboard.Selling.EmailOffers || {};
window.Reverb.Dashboard.Selling.EmailOffers.EmailOfferForm = require('./components/dashboard/selling/email_offers/email_offer_form.jsx');
window.Reverb.Dashboard.Selling.ListingsManager =
  window.Reverb.Dashboard.Selling.ListingsManager || {};
window.Reverb.Dashboard.Selling.ListingsManager.BulkSalebutton = require('./components/dashboard/selling/listings_manager/sales/bulk_sale_button.jsx');
window.Reverb.Dashboard.Selling.OrderNotes = require('./components/dashboard/selling/order_notes/order_notes.jsx');
window.Reverb.Dashboard.ShopPaymentMethodSelectionContainer = require('./components/dashboard/selling/shop_policies/containers/payment_method_selection_container.jsx');
window.Reverb.Dashboard.ShopDirectCheckoutProfile = require('./components/dashboard/selling/shop_policies/direct_checkout_profile.jsx');
window.Reverb.Dashboard.AcceptedPaymentMethodsForm = require('./components/dashboard/selling/shop_policies/accepted_payment_methods_form.jsx');
window.Reverb.Dashboard.BumpBid = require('./components/dashboard/selling/bump_for_new/bump_bid.jsx');
window.Reverb.Dashboard.Reports = require('./components/dashboard/selling/reports/reports.jsx');
window.Reverb.ProductPageBump = require('./components/dashboard/selling/bump_for_new/product_page_bump.jsx');

window.Reverb.EmailSignup = require('./components/email_signup/email_signup.jsx');
window.Reverb.ExperimentToggler = require('@reverbdotcom/experiment-toggler');

window.Reverb.GiftCard = window.Reverb.GiftCard || {};
window.Reverb.GiftCard.GiftCardOptions = require('./components/gift_cards/gift_card_options');

window.Reverb.ListingForm = window.Reverb.ListingForm || {};
window.Reverb.ListingForm.CanonicalProductMatcher = require('./components/listing_form/canonical_product_matcher.jsx');
window.Reverb.ListingForm.LocalizedContent = require('./components/listing_form/localized_content.jsx');
window.Reverb.ListingForm.Videos = require('./components/listing_form/videos.jsx');
window.Reverb.ListingForm.ConditionExplanation = require('./components/listing_form/condition_explanation.jsx');
window.Reverb.ListingForm.MakeModel = require('./components/listing_form/make_model.jsx');
window.Reverb.ListingForm.ListingAttributes = require('./components/listing_form/listing_attributes.jsx');
window.Reverb.ListingForm.ListingAttributesContainer = require('./components/listing_form/listing_attributes_container');

window.Reverb.Photos = require('./components/photos/photos.jsx');
window.Reverb.Loading = require('./components/shared/loading.jsx');
window.Reverb.ManualShippingInfoForm = require('./components/manual_shipping_info_form.jsx');
window.Reverb.OfferInput = require('./components/offers/offer_input.jsx');
window.Reverb.OfferModal = require('./components/offers/offer_modal.jsx');
window.Reverb.PageSearchBar = require('./components/shared/page_search_bar.jsx');
window.Reverb.PreviousOrders = require('./components/previous_orders.jsx');
window.Reverb.PriceGuideChart = require('./components/price_guide/transaction_history/chart.jsx');
window.Reverb.PriceGuideTable = require('./components/price_guide/transaction_history/table.jsx');
window.Reverb.ProductBundleForm = require('./components/product_bundles/product_bundle_form.jsx');
window.Reverb.ProductBundlePromo = require('./components/product_bundles/promo.jsx');
window.Reverb.ProductReviews = require('./components/product_reviews/product_reviews.jsx');
window.Reverb.ProgressBar = require('./components/shared/progress-bar.jsx');
window.Reverb.ReferAFriendSocialButtons = require('./components/refer_a_friend_social_buttons.jsx');

window.Reverb.BankAccountFields = require('./components/shop/direct_checkout_profile/bank_account_fields.jsx');
window.Reverb.BankTransferRequests = window.Reverb.BankTransferRequests || {};
window.Reverb.BankTransferRequests.BankAccountForm = require('./components/bank_transfer_requests/bank_account_form.jsx');
window.Reverb.BankTransferRequests.AmountFields = require('./components/bank_transfer_requests/amount_fields.jsx');

window.Reverb.ShareInput = require('./components/shared/share_input.jsx');
window.Reverb.Fotorama = require('./components/shared/fotorama.jsx');
window.Reverb.ShippingLabelAddressBox = require('./components/shipping_labels/address_box.jsx');
window.Reverb.ShopPaymentMethodSelector = require('./components/shop/payment_method_selector.jsx');
window.Reverb.ShopPaypalProfile = require('./components/shop/paypal_profile.jsx');
window.Reverb.ShopCurrencySelect = require('./components/shop/currency_select.jsx');
window.Reverb.StreetAddressInput = require('./components/bundled_checkout/street_address_input.jsx');
window.Reverb.Tooltip = require('./components/tooltip.jsx');
window.Reverb.UserBadges = require('./components/user_badges.jsx');
window.Reverb.DigitalListingDownloadButton = require('./components/digital_listings/standalone_download_button.jsx');

window.Reverb.ProductShowPage = {};
window.Reverb.ProductShowPage.Upsells = require('./components/product_show_page/upsells.jsx');
window.Reverb.ProductShowPage.SidebarUpsells = require('./components/product_show_page/sidebar_upsells.jsx');
window.Reverb.ProductShowPage.RelatedContent = require('./components/product_show_page/related_content.jsx');
window.Reverb.ProductShowPage.SimilarListings = require('./components/product_show_page/similar_listings.jsx');
window.Reverb.ProductShowPage.AutoProductBundles = require('./components/product_show_page/auto_product_bundles.jsx');

window.Reverb.CartUpsells = require('./components/cart/cart_upsells.jsx');

window.Reverb.Listings = window.Reverb.Listings || {};
window.Reverb.Listings.StandaloneAjaxAddToCartButton = require('./components/listings/cart/standalone_ajax_add_to_cart_button.jsx');
window.Reverb.Listings.WatchButton = require('./components/listings/watch_button.jsx');

window.Reverb.Conversations = {};
window.Reverb.Conversations.Embeds = require('./components/conversations/embeds.jsx');
window.Reverb.Conversations.BodyInput = require('./components/conversations/body_input.jsx');

window.Reverb.CartBadge = require('./components/header/cart/cart_badge.jsx');
window.Reverb.ShippingLabels = {};
window.Reverb.ShippingLabels.ShippingDetailsContainer = require('./components/shipping_labels/containers/details_container.jsx');
window.Reverb.ShippingRatesEditor = require('./components/shipping_rates_editor.jsx');

window.Reverb.ZopimActions = require('./components/zopim/zopim_actions.js');
window.Reverb.Zendesk = require('./components/zendesk.js');
window.Reverb.HelpDropdown = require('./components/header/help_dropdown.jsx');
window.Reverb.NavLinks = require('./components/header/nav_links.jsx');
window.Reverb.Events = require('./components/event_tracking.js');
window.Reverb.NavDropdownStore = require('./components/header/dropdown_store.js');

window.Reverb.Articles = {};
window.Reverb.Articles.RelatedArticles = require('./components/articles/related_articles.jsx');

window.Reverb.ReactUJS = require('./components/react_ujs.js');



// WEBPACK FOOTER //
// ./javascripts/components.js